import React,{useState, useEffect} from 'react'
import { Link, BrowserRouter as Router, Route, Switch, useRouteMatch, useHistory } from "react-router-dom";
import './blog.css'
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import Footer from '../../Home/Home_modules/Footerr/footer'
import titleemoji from './Im/title_icon.png'


export default function Blog(props){
    const responsive = {
        superLargeDesktop: {
          // the naming can be any, depends on you.
          breakpoint: { max: 4000, min: 3000 },
          items: 1
        },
        desktop: {
          breakpoint: { max: 3000, min: 1024 },
          items: 1
        },
        tablet: {
          breakpoint: { max: 1024, min: 464 },
          items: 1
        },
        mobile: {
          breakpoint: { max: 464, min: 0 },
          items: 1
        }
      };

      const [blogData, setBlogData] = useState([]);

    /*  useEffect(() => {
        const blogRef = firebase.firestore().collection('blogs');

        blogRef.get().then((snapshot) => {
          const data = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
          setBlogData(data);
         // console.log("All data in blogs collection", data); 
        });
    }, []); */

    const [posts, setPosts] = useState([]);
    useEffect(() => {
        fetch('https://temp.gadgetsfresh.com/wp-json/wp/v2/posts?_embed')
    .then(res => res.json())
    .then(data => {
       // console.log(data);
        setPosts(data);
    })
    .catch(err => console.log(err));
}, []);
    console.log(posts);

    return(
        <>
        <div className="main">
            <div className="blog-header">
                <div>
                    <h1 className="blog-header-title">DIGINOOR BLOG</h1>
                </div>
                <div>
                <img className='blog-head-emoji' src={titleemoji} alt="blog title" />
                </div>
           {/*     <div>
                    <button className="blog-follow-btn">Follow</button>
                    <button className="blog-share-btn"><i className="fas fa-share-square" ></i></button>
           </div> */}
            </div>


            {/* Blog Featured Section */}
            <div className="blog-featured-sec">
            <Carousel 
            responsive={responsive}
            autoPlay={true}
            autoPlaySpeed={5000}
            infinite={true}
            >
                {
                    posts.map((item) => {
                        if(item.featured == "yes"){
                        return(
                            <Link to={`/blog/${item.slug}`}>
                            <div key={item.id} className="blog-featured">
                    <div className="blog-featured-img">
                        <img src={item.featured_media_src_url} alt=""/>
                        </div>
                        <div className="blog-featured-content">
                            <h1>{item.title.rendered}</h1>
                            <div className="blog-post-meta">
                            <a>{item._embedded.author[0].name}</a>
                            <a>{item.date}</a>
                            </div>
                            <div className="blog-post-excerpt">
                                <p dangerouslySetInnerHTML={{ __html:item.excerpt.rendered}} />
                                Read more.
                            </div>
                            </div>
                </div>
                </Link>
                        )
                        }
                    })
                }
                
                </Carousel>
            </div>
            
            {/* Blog Posts Section */}

            <div className="blog-post-grid">


        { posts.map((data) => {
        return(
        
                <Link to={`/blog/${data.slug}`}>
                    <div key={data.id} className="post-grid-col1">
                    <img className="blog-post-img" src={data.featured_media_src_url} alt=""/>
                    <div className="blog-post-content">
                        <h1>{data.title.rendered}</h1>
                        <div className="blog-post-meta">
                            <a>{data._embedded.author[0].name}</a>
                            <a>{data.date}</a>
                          {/* <p>{data.content.rendered}</p> */}
                            </div>
                    </div>
                </div>
                </Link>
             /*   <div className="post-grid-col2">
                    <img className="blog-post-img" src={Postimg} alt=""/>
                    <div className="blog-post-content">
                        <h1>Beginners guide to NFT</h1>
                        <div className="blog-post-meta">
                            <a>Author name</a>
                            <a>2nd Dec, 2021</a>
                            </div>
                    </div>
        </div> */
           
        )
    }
    )
    }
</div>
        </div>
        <Footer/>
        </>
    )
}